import { GetClassNamesParams } from './Spinner.types';

const sizeClass = (prefix: string) => `${prefix}-size`;
const animationTypeClass = (prefix: string) => `${prefix}-animation-type`;
const strokeWidthClass = (prefix: string) => `${prefix}-stroke-width`;

export function getClassNames(params: GetClassNamesParams) {
    const { cx, size, externalClassNames, strokeWidth, animationType, theme } = params;
    const { className, spinnerClassName, circleClassName } = externalClassNames;

    const rootClassNames = cx(sizeClass(size), className);

    const spinnerClassNames = cx('spinner', animationTypeClass(animationType), spinnerClassName);

    const circleClassNames = cx('circle', strokeWidthClass(strokeWidth), circleClassName, {
        [`circle_theme_${theme}`]: Boolean(theme),
    });

    return {
        rootClassNames,
        spinnerClassNames,
        circleClassNames,
    };
}
